export const DELAY_SHOW = 350;
